// Utility functions for inventory assignment management

export const getInitialInventoryAssignmentFormData = () => ({
  assigned_to_id: '',
  inventory_item_id: '',
  quantity: '',
  assigned_date: new Date().toISOString().split('T')[0], // Today's date
  remarks: '',
});

export const getInventoryAssignmentFormDataFromRecord = (assignment) => ({
  assigned_to_id: assignment.assigned_to?.id || assignment.assigned_to_id || '',
  inventory_item_id: assignment.inventory_item?.id || assignment.inventory_item_id || '',
  quantity: assignment.quantity || '',
  assigned_date: assignment.assigned_date ? new Date(assignment.assigned_date).toISOString().split('T')[0] : '',
  remarks: assignment.remarks || '',
});

export const formatInventoryAssignmentDataForSubmission = (formData) => {
  const submissionData = {
    assigned_to_id: parseInt(formData.assigned_to_id, 10),
    inventory_item_id: parseInt(formData.inventory_item_id, 10),
    quantity: parseInt(formData.quantity, 10),
    assigned_date: formData.assigned_date,
    remarks: formData.remarks?.trim() || '',
  };

  return submissionData;
};

export const getInitialInventoryAssignmentFormDataWithItem = (inventoryItem) => ({
  assigned_to_id: '',
  inventory_item_id: inventoryItem?.id || '',
  quantity: '1',
  assigned_date: new Date().toISOString().split('T')[0], // Today's date
  remarks: '',
});

export const getAssignmentStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'assigned':
      return 'primary';
    case 'returned':
      return 'success';
    case 'overdue':
      return 'error';
    case 'lost':
      return 'error';
    default:
      return 'default';
  }
};

export const getAssignmentStatusText = (status) => {
  switch (status?.toLowerCase()) {
    case 'assigned':
      return 'Assigned';
    case 'returned':
      return 'Returned';
    case 'overdue':
      return 'Overdue';
    case 'lost':
      return 'Lost';
    default:
      return 'Unknown';
  }
};

export const formatAssignmentDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString();
};

export const canReturnAssignment = (assignment) => 
  assignment?.status?.toLowerCase() === 'assigned' && !assignment.return_date;